import { useDispatch, useSelector } from 'react-redux';

import { globalConfirmModalSelectors } from './selectors';
import { globalConfirmModalActions } from './slice';
import { type OpenConfirmModalPayload } from './types';

export const useGlobalConfirmModalState = () => {
  return useSelector(globalConfirmModalSelectors.getState);
};

export const useGlobalConfirmModalActions = () => {
  const dispatch = useDispatch();

  const openConfirmModal = (payload: OpenConfirmModalPayload) => {
    dispatch(globalConfirmModalActions.openModal(payload));
  };

  const closeConfirmModal = () => {
    dispatch(globalConfirmModalActions.closeModal());
  };

  return { openConfirmModal, closeConfirmModal };
};
